<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Button class="mr" type="primary" icon="ios-add-circle-outline" @click="addSchoolJobShow">新增企业</Button>
				<Upload :action="importCompany">
					<Button icon="ios-cloud-upload-outline">批量导入企业</Button>
				</Upload>
				<a @click="importTemplate">下载导入模板</a>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button v-if="row.status=='1'" type="warning" size="small" style="margin-right: 5px"
						@click="updateSchoolStatus(row.id,0)">停用</Button>
					<Button v-if="row.status=='0'" type="success" size="small" style="margin-right: 5px"
						@click="updateSchoolStatus(row.id,1)">启用</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="600">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">

				<FormItem label="企业logo" prop="logoUrl">
					<Upload :action="uploadFile" name="file" :on-success="logoImgBack" :data="uploadData"
						accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传logo</Button>
					</Upload>
				</FormItem>
				<FormItem label="企业类型">
					<Input v-model="addForm.companyType" maxlength="100" placeholder="请输入企业类型" clearable></Input>
				</FormItem>
				<FormItem label="行业类型">
					<Input v-model="addForm.industryType" maxlength="50" placeholder="请输入行业类型" clearable></Input>
				</FormItem>
				<FormItem label="简称" prop="shortName">
					<Input v-model="addForm.shortName" maxlength="255" placeholder="请输入简称" clearable></Input>
				</FormItem>
				<FormItem label="默认背景色">
					<RadioGroup v-model="addForm.bgColor">
						<Radio v-for="item in bgColors" :label="item.value" :key="item.value" ><span
								:style="'color:#'+item.value">{{ item.label }}</span></Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="标题" prop="jobTitle">
					<Input v-model="addForm.jobTitle" maxlength="255" placeholder="请输入标题" clearable></Input>
				</FormItem>
				<FormItem label="标签">
					<Input v-model="addForm.jobTag" maxlength="255" placeholder="请输入标签" clearable></Input>
				</FormItem>
				<FormItem label="城市" prop="city">
					<Input v-model="addForm.city" maxlength="10" placeholder="请输入城市(多个逗号隔开)" clearable></Input>
				</FormItem>
				<FormItem label="入选榜单">
					<Input v-model="addForm.rankInfo" maxlength="100" placeholder="请输入入选榜单" clearable></Input>
				</FormItem>
				<FormItem label="想入职比例">
					<Input type="number" v-model="addForm.joinRate" maxlength="100" placeholder="请输入想入职比例,例如:0.2"
						clearable></Input>
				</FormItem>
				<FormItem label="收录集合">
					<Input v-model="addForm.collectInfo" maxlength="100" placeholder="请输入收录集合" clearable></Input>
				</FormItem>
				<FormItem label="浏览增配倍数" prop="visitIncr">
					<Input v-model="addForm.visitIncr" maxlength="50" placeholder="请输入浏览增配倍数,例如:1,3 表示随机增配1到3倍"
						clearable></Input>
				</FormItem>
				<FormItem label="是否置顶">
					<RadioGroup v-model="addForm.fixTop">
						<Radio label="0">否</Radio>
						<Radio label="1">是</Radio>
					</RadioGroup>
				</FormItem>

				<FormItem label="是否内推">
					<RadioGroup v-model="addForm.innerRecommend">
						<Radio label="0">否</Radio>
						<Radio label="1">是</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem v-if="addForm.innerRecommend=='1'" label="内推时间" prop="salary">
					<Input v-model="addForm.innerRecommendDate" placeholder="请输入内推时间" clearable></Input>
				</FormItem>
				<FormItem label="开始时间" prop="startDate">
					<DatePicker type="date" v-model="addForm.startDate" format="yyyy-MM-dd" placement="bottom-end"
						placeholder="请选择" style="width:100%" />
				</FormItem>
				<FormItem label="结束时间" prop="endDate">
					<DatePicker type="date" v-model="addForm.endDate" format="yyyy-MM-dd" placement="bottom-end"
						placeholder="请选择" style="width:100%" />
				</FormItem>
				<FormItem label="国内生毕业日期">
					<Input v-model="addForm.innerGraduateDate" placeholder="请输入国内生毕业日期" clearable></Input>
				</FormItem>
				<FormItem label="留学生毕业日期">
					<Input v-model="addForm.outGraduateDate" placeholder="请输入留学生毕业日期" clearable></Input>
				</FormItem>
				<FormItem label="校招岗位" prop="jobPost">
					<Input v-model="addForm.jobPost" placeholder="请输入校招岗位(多个逗号隔开)" clearable></Input>
				</FormItem>

				<FormItem label="信息详情" prop="detailType">
					<RadioGroup v-model="addForm.detailType">
						<Radio label="1">图片</Radio>
						<Radio label="2">文本</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem v-if="addForm.detailType=='1'" label="详情图片">
					<Upload :action="uploadFile" name="file" :on-success="detailImgBack" :data="uploadData"
						accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
				<FormItem v-if="addForm.detailType=='2'" label="详情文本">
					<Input v-model="addForm.detailTextTitle" placeholder="请输入总标题" clearable>
					<template #prepend>
						总标题
					</template>
					</Input>
					<Button style="margin-top: 10px;" @click="addDetailTxt">添加副标题</Button>
					<div style="margin-top: 10px;" v-for="item in addForm.detailTextArr" :key="item.id">
						<div>
							<div class="detail">
								<Input v-model="item.tilte" placeholder="请输入标题" clearable>
								<template #prepend>
									标题
								</template>

								</Input>
								<div @click="delDetailTxt(item.id)" style="width: 30px;">
									删除
								</div>
							</div>
							<Input type="textarea" v-model="item.content" placeholder="请输入内容" clearable>
							</Input>
						</div>
					</div>
				</FormItem>
				<FormItem label="扫码添加">
					<Upload :action="uploadFile" name="file" :on-success="codeImgBack" :data="uploadData"
						accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
				<FormItem label="排序">
					<Input type="number" v-model="addForm.sortIndex" placeholder="请输入排序(数值越大越靠前)"></Input>
				</FormItem>
				<FormItem label="状态">
					<i-switch v-model="addForm.status==1" size="large" @on-change="changeStatus($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrEditData">确认提交</Button>
			</div>
		</Modal>


	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition8'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				importCompany: api.statistics.importCompany,
				tmpLink: api.statistics.tmpLink,
				uploadData: {
					filePath: 'img'
				},
				queryParams: {

				},
				codeImgs: [],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				bgColors: [{
					value: 'adddf3',
					label: '蓝色'
				}, {
					value: 'f7e4ff',
					label: '紫色'
				}, {
					value: '90cfb7',
					label: '绿色'
				}, {
					value: 'e79178',
					label: '暖橙'
				}, {
					value: 'ae98c6',
					label: '深紫'
				}, ],
				addForm: {
					id: undefined,
					logoUrl: '',
					companyType: '',
					industryType: '',
					shortName: '',
					bgColor: 'f7e4ff',
					jobTitle: '',
					jobTag: '',
					city: '',
					rankInfo: '',
					joinRate: 0,
					collectInfo: '',
					visitIncr: '',
					fixTop: '0',
					sortIndex: 0,
					innerRecommend: '0',
					innerRecommendDate: '',
					startDate: undefined,
					endDate: undefined,
					innerGraduateDate: '',
					outGraduateDate: '',
					jobPost: '',
					detailType: '',
					detailImg: '',
					detailText: '',
					qrCodeUrl: '',
					status: 0,
					detailTextTitle: '',
					detailTextArr: [],
				},
				addRule: {
					logoUrl: [{
						required: true,
						message: '请上传企业logo',
						trigger: 'blur',
					}],
					jobTitle: [{
						required: true,
						message: '请填写标题',
						trigger: 'blur'
					}],
					city: [{
						required: true,
						message: '请填写城市',
						trigger: 'blur'
					}, ],
					visitIncr: [{
						required: true,
						message: '请填写增比倍数',
						trigger: 'blur'
					}, ],
					jobPost: [{
						required: true,
						message: '请填写校招岗位',
						trigger: 'blur'
					}, ],
					detailType: [{
						required: true,
						message: '请选择详情类型',
						trigger: 'blur'
					}, ]
				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: 'ID',
						width: 160,
						key: 'id',
						align: 'center'
					},
					{
						title: '标题',
						width: 350,
						key: 'jobTitle',
						align: 'center'
					},
					{
						title: '置顶',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.fixTop;
							if (val == 1) {
								name = '置顶'
							} else {
								name = '未置顶'
							}
							return h('span', name)
						}
					},
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == '1') {
								name = '启用'
							} else {
								name = '停用'
							}
							return h('span', name)
						}
					}, {
						title: '创建日期',
						key: 'updateTime',
						align: 'center',
						width: 200,
					}, {
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}

				]
			},

		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.schoolJobPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addSchoolJobShow() {
				this.addForm = {
					id: undefined,
					logoUrl: '',
					companyType: '',
					industryType: '',
					shortName: '',
					bgColor: '',
					jobTitle: '',
					jobTag: '',
					city: '',
					rankInfo: '',
					joinRate: 0,
					collectInfo: '',
					visitIncr: '',
					fixTop: '0',
					sortIndex: 0,
					innerRecommend: '0',
					innerRecommendDate: '',
					startDate: '',
					endDate: '',
					innerGraduateDate: '',
					outGraduateDate: '',
					jobPost: '',
					detailType: '',
					detailImg: '',
					detailText: '',
					qrCodeUrl: '',
					status: 0,
					detailTextTitle: '',
					detailTextArr: [],
				}
				this.addJobShow = true
			},
			logoImgBack(response, file, fileList) {
				this.addForm.logoUrl = response.data.url
			},
			detailImgBack(response, file, fileList) {
				this.addForm.detailImg = response.data.url
			},
			codeImgBack(response, file, fileList) {
				this.addForm.qrCodeUrl = response.data.url
			},
			addDetailTxt() {
				let data = this.addForm.detailTextArr || []
				data.push({
					id: this.util.uuid(),
					title: '',
					content: ''
				})
				this.$set(this.addForm, 'detailTextArr', data)
			},
			delDetailTxt(id) {
				this.addForm.detailTextArr = this.addForm.detailTextArr.filter(item => {
					return item.id != id
				})
			},
			addOrEditData(row) {
				const that = this
				let addData = {
					...that.addForm
				}
				addData.detailText = JSON.stringify(addData.detailTextArr)
				if (addData.startDate) {
					addData.startDate = this.util.dateFormat(addData.startDate, 'yyyy-MM-dd')
				}
				if (addData.endDate) {
					addData.endDate = this.util.dateFormat(addData.endDate, 'yyyy-MM-dd')
				}
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						api.statistics
							.addOrEditSchoolJob(addData)
							.then(res => {
								that.addJobShow = false
								that.refreshData()
							})
					}
				})
			},
			changeStatus(state, data) {
				this.addForm.status = state ? '1' : '0'
			},
			updateSchoolStatus(id, status) {
				const that = this
				api.statistics
					.updateSchoolJobStatus({
						'id': id,
						status: status
					})
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			editData(data) {
				this.addForm = data
				if (data.detailText) {
					let detailTextArr = JSON.parse(data.detailText) || []
					this.$set(this.addForm, 'detailTextArr', detailTextArr)
				}
				this.addJobShow = true
			},
			/** 下载模板操作 */
			importTemplate() {
				const that = this
				api.statistics.importTemplate().then(res => {
					that.util.excel(res, "导入企业模板")
				});
			},
		},

	}
</script>
<style>
	.detail {
		display: flex;
		flex-direction: row;
	}
</style>